import { useSyncExternalStore } from 'react';
import { isTouchViewport } from '@/hooks/use-mobile';

// The on-screen keyboard shrinks the visual viewport but not the layout
// viewport (iOS Safari, and Android Chrome since 108). More than this many
// pixels of difference means a keyboard rather than a toolbar animating.
const KEYBOARD_MIN_HEIGHT = 150;

export const isKeyboardOpen = () => {
	if (typeof window === 'undefined' || !isTouchViewport()) return false;
	const vv = window.visualViewport;
	if (!vv || Math.abs(vv.scale - 1) > 0.01) return false;
	return window.innerHeight - vv.height > KEYBOARD_MIN_HEIGHT;
};

const subscribe = (onChange: () => void) => {
	const vv = window.visualViewport;
	vv?.addEventListener('resize', onChange);
	window.addEventListener('resize', onChange);
	return () => {
		vv?.removeEventListener('resize', onChange);
		window.removeEventListener('resize', onChange);
	};
};

/**
 * True while the on-screen keyboard is up on a phone. Use it to drop
 * home-indicator padding under a composer or to hide bottom chrome. In CSS,
 * the `kb-open:` variant does the same.
 */
export function useKeyboardOpen() {
	return useSyncExternalStore(subscribe, isKeyboardOpen, () => false);
}
